<template>
  <div class="modal-overlay">
    <div class="mmodal-content" style="max-width: 80vw">
      <div class="modal-header">
        <h3>{{ editingRecord ? "Edit" : "Add" }} Skin Examination</h3>
        <button type="button" class="close" @click="closeModal">&times;</button>
      </div>
      <div class="modal-body">
        <form @submit.prevent="saveRecord">
          <div class="form-grid">
            <div class="form-group">
              <label>Date Examined *</label>
              <input type="datetime-local" v-model="form.examined_at" required class="form-control" />
            </div>

            <div class="form-group ">
              <label>Lesion Site *</label>
              <input type="text" v-model="form.lesion_site" required class="form-control" />
            </div>

            <div class="form-group ">
              <label>Distribution</label>
              <select v-model="form.distribution"  class="form-control">
                <option value="">Select</option>
                <option value="Localized">Localized</option>
<option value="Generalized">Generalized</option>
<option value="Symmetric">Symmetric</option>
<option value="Asymmetric">Asymmetric</option>
<option value="Linear">Linear</option>
<option value="Grouped">Grouped</option>
              </select>
            </div>

            <div class="form-group ">
              <label>Duration</label>
              <input type="text" v-model="form.duration" placeholder="e.g. 2 weeks"  class="form-control" />
            </div>

            <div class="form-group full-width">
              <label>Lesion Description</label>
              <textarea v-model="form.lesion_description" class="form-control" rows="2"></textarea>
            </div>

            <div class="form-group">
              <label class="checkbox-label">
                <input type="checkbox" v-model="form.biopsy_taken" />
                Biopsy taken
              </label>
            </div>

            <div class="form-group full-width">
              <label>Biopsy Result</label>
              <textarea v-model="form.biopsy_result" class="form-control" rows="2"></textarea>
            </div>

            <div class="form-group full-width">
              <label>Provisional Diagnosis</label>
              <textarea v-model="form.provisional_diagnosis" class="form-control" rows="2"></textarea>
            </div>

            <div class="form-group full-width">
              <label>Treatment Given</label>
              <textarea v-model="form.treatment_given" class="form-control" rows="2"></textarea>
            </div>

            <div class="form-group full-width">
              <label>Complications</label>
              <textarea v-model="form.complications" class="form-control" rows="2"></textarea>
            </div>

            <div class="form-group full-width">
              <label>Notes</label>
              <textarea v-model="form.notes" class="form-control" rows="2"></textarea>
            </div>

            <div class="form-group ">
              <label>Examined By</label>
              <input type="text" v-model="form.examined_by"  class="form-control" />
            </div>
          </div>

          <div class="modal-actions">
            <button type="button" class="btn btn-secondary" @click="closeModal">Cancel</button>
            <button type="submit" class="btn btn-primary" :disabled="saving">
              {{ saving ? "Saving..." : (editingRecord ? "Update" : "Save") + " Examination" }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { generalApiRequest } from "../../../api/apiIndex";

export default {
  name: "DermatologyExaminationModal",
  props: {
    visitId: { type: [Number, String], default: null },
    editRecord: { type: Object, default: null },
  },
  data() {
    return {
      saving: false,
      editingRecord: null,
      form: this.emptyForm(),
    };
  },
  created() {
    if (this.editRecord) {
      this.editingRecord = this.editRecord;
      this.form = {
        ...this.emptyForm(),
        ...this.editRecord,
        examined_at: this.toLocalDateTime(this.editRecord.examined_at),
      };
    }
  },
  methods: {
    emptyForm() {
      return {
        examined_at: this.toLocalDateTime(new Date()),
        lesion_site: "",
        distribution: "",
        duration: "",
        lesion_description: "",
        biopsy_taken: false,
        biopsy_result: "",
        provisional_diagnosis: "",
        treatment_given: "",
        complications: "",
        notes: "",
        examined_by: ""
      };
    },
    toLocalDateTime(value) {
      if (!value) return "";
      const d = new Date(value);
      if (isNaN(d.getTime())) return "";
      const pad = (n) => String(n).padStart(2, "0");
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
    },
    closeModal() {
      this.$emit("close");
    },
    async saveRecord() {
      this.saving = true;
      try {
        const payload = { ...this.form, visit_id: this.visitId };
        let response;
        if (this.editingRecord) {
          response = await generalApiRequest(`dermatology_examinations/${this.editingRecord.id}`, "PUT", payload, 1);
        } else {
          response = await generalApiRequest("dermatology_examinations", "POST", payload, 1);
        }
        if (response.success) {
          this.$emit("saved", response.data);
          this.closeModal();
        } else {
          alert(response.message || "Failed to save record");
        }
      } catch (error) {
        console.error("Error saving record:", error);
        alert("An error occurred while saving");
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<style scoped>
.modal-overlay { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center; z-index: 1000; }
.mmodal-content { background: white; border-radius: 10px; max-height: 90vh; overflow-y: auto; display: flex; flex-direction: column; }
.modal-header { padding: 20px; background: linear-gradient(135deg, #dd6b20 0%, #9c4221 100%); color: white; display: flex; justify-content: space-between; align-items: center; }
.modal-header h3 { margin: 0; font-size: 20px; }
.close { background: rgb(233, 22, 22); border: 1px solid rgb(182, 178, 178); font-size: 1.5rem; color: white; line-height: 1; cursor: pointer; }
.modal-body { padding: 30px; overflow-y: auto; flex-grow: 1; }
.form-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px; margin-bottom: 20px; }
.form-group { margin-bottom: 15px; }
.form-group.full-width { grid-column: 1 / -1; }
.form-group label { display: block; margin-bottom: 5px; font-weight: 600; color: #495057; }
.checkbox-label { display: flex !important; align-items: center; gap: 8px; margin-top: 28px; }
.form-control { width: 100%; padding: 10px; border: 1px solid #ddd; border-radius: 5px; font-size: 14px; }
.modal-actions { display: flex; justify-content: flex-end; gap: 15px; }
.btn { padding: 10px 25px; border: none; border-radius: 5px; cursor: pointer; font-weight: 600; }
.btn-secondary { background: #6c757d; color: white; }
.btn-secondary:hover { background: #5a6268; }
.btn-primary { background: #9c4221; color: white; }
.btn-primary:hover { opacity: 0.9; }
.btn-primary:disabled { opacity: 0.6; cursor: not-allowed; }
@media (max-width: 1200px) { .form-grid { grid-template-columns: repeat(2, 1fr); } }
@media (max-width: 768px) { .form-grid { grid-template-columns: 1fr; } }
</style>
